<template>
  <div class="mb-1">{{ companyNonConsultUsers.length ? $t('MANAGE.CHOOSE_NEW_OWNER') : $t('MANAGE.NO_NEW_OWNER_AVAILABLE') }}</div>
  <div v-bind="$attrs">
    <select-user v-model="newOwner.user" :items="companyNonConsultUsers"
                 :disabled="! companyNonConsultUsers.length" class="my-1" style="max-width: 360px;">
    </select-user>
    <v-btn :disabled="! newOwner.user?.id || newOwner.user.id == currentOwnerId || newOwner.sending" color="primary" rounded size="large" class="my-1" @click="setNewOwner()">
      {{ $t('MANAGE.SET_OWNER') }}
    </v-btn>
  </div>
</template>

<script>
  import useUiMsgboxStore from '@/stores/ui/msgbox';
  import useUsersStore from '@/stores/users';

  export default {
    props: {
      project: { type: Object, required: true },
    },
    emits: ['change-owner'],
    data() {
      return {
        newOwner: { user: null, sending: null },
        uiMsgboxStore: useUiMsgboxStore(),
        usersStore: useUsersStore(),
      };
    },
    computed: {
      currentOwnerId() {
        return this.project.owner_id;
      },
      subcompaniesUsers() {
        if (this.usersStore.user.organization) {
          const subcompanies = this.usersStore.getOrganizationSubCompanies;
          return subcompanies.map(company => company.users).reduce((acc, val) => acc.concat(val), []); // reduce(...) could be replaced by flat() with ie polyfill
        }
        return this.usersStore.getCompanyUsers;
      },
      companyNonConsultUsers() {
        return this.subcompaniesUsers.filter(user => user.access_right != 'consult');
      },
    },
    watch: {
      'project.owner_id': {
        handler(newVal) {
          this.newOwner.user = this.companyNonConsultUsers.find(user => user.id == newVal);
        },
        immediate: true,
      },
    },
    methods: {
      setNewOwner() {
        const projectId = this.project.id;
        const ownerId = this.newOwner.user && this.newOwner.user.id;
        if (! ownerId) return;
        this.newOwner.sending = true;
        window.apiSrv.call(`plannings/${projectId}/admin`, 'update', { owner_id: ownerId }).then(() => {
          this.newOwner = { user: null, sending: null };
          this.$emit('change-owner', { projectId, ownerId });
        }).catch((message) => {
          this.uiMsgboxStore.open({ title: "Error : Owner was not modified", body: message || "" });
          this.newOwner.sending = false;
        });
      },
    },
  };
</script>
